var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8253 14.6286C13.9206 14.867 13.9206 15.133 13.8253 15.3714L11.7659 20.5198L21.7015 15L11.7659 9.48023L13.8253 14.6286ZM11.6712 14.6286C11.7666 14.867 11.7666 15.133 11.6712 15.3714L8.86437 22.3885C8.51488 23.2622 9.45587 24.0911 10.2785 23.6341L24.2463 15.8742C24.9321 15.4932 24.9321 14.5069 24.2463 14.1258L10.2785 6.36596C9.45587 5.90895 8.51488 6.73777 8.86437 7.61151L11.6712 14.6286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.2ded71d48282053618f810b6b0d3d2ff.svg";
export { ForwardRef as ReactComponent };